import React, { useRef, useState, useCallback } from "react";
import Webcam from "react-webcam";
import "./cameraUpload.css";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import CloseIcon from "../../assets/images/Icons/closeIcon.svg";
import { useEffect } from "react";
import { Buffer } from "buffer";
const CameraUpload = ({
  show,
  setShow,
  onHide,
  isCamera,
  setIsCamera,
  isWbCamEnabled,
  setWebCamEnabled,
  setVisitorPhoto,
  visitorPhoto,

  cameraLabel,
}) => {
  const webcamRef = useRef(null);
  const [imgSrc, setImgSrc] = useState(false);

  const handleClose = () => {
    setImgSrc("");
    setShow(false);
    // setIsCamera(false);
    // setShow(false); //newly added
  };

  let imageSrc = "";
  const capture = useCallback(() => {
    imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
    return true;
  }, [webcamRef, setImgSrc]);
  const base64ToFile = async (base64) => {
    const res = await fetch(base64);
    const buf = await res.arrayBuffer();
    const file = new File(
      [buf],
      "visitor" + imgSrc.slice(5, 15).replace("/", "."),
      {
        type: "image/jpeg",
      }
    );

    return file;
  };
  const savePhoto = async () => {
    let convertImge = await base64ToFile(imgSrc);

    setVisitorPhoto(convertImge);
    cameraLabel = convertImge.name;
  };

  return (
    <div className="cameraContainer">
      <Modal show={show} className="cameraModal">
        <Modal.Body className="outerModalContainer">
          <div>
            <div className="showCamera">
              {imgSrc == "" ? (
                <div>
                  <div
                    className="clseButton"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    <img className="btnClose" src={CloseIcon} alt="Close" />
                  </div>
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    className="vedio-contanier"
                  />
                  <button
                    onClick={() => {
                      capture();
                    }}
                    className="captureBtn"
                  >
                    CAPTURE
                  </button>
                </div>
              ) : (
                <div>
                  <div
                    className="clseButton"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    <img className="btnClose" src={CloseIcon} alt="Close" />
                  </div>
                  <img src={imgSrc} className="image-container" />

                  <Row className="button-align">
                    <Col>
                      <button
                        onClick={() => {
                          setIsCamera(true);
                          setImgSrc("");
                          capture();
                        }}
                        className="planCameraButton"
                      >
                        RETAKE PHOTO
                      </button>
                    </Col>
                    <Col>
                      <button
                        onClick={() => {
                          savePhoto();
                        }}
                        className="savecameraButton"
                      >
                        SAVE PHOTO
                      </button>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CameraUpload;
